var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { RootLayout } from "../root/root.component";
import { logintTypeCorpo, logintTypeInd } from "../../../common/constant";
var ExecutiveLayout = /** @class */ (function (_super) {
    __extends(ExecutiveLayout, _super);
    function ExecutiveLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuItems = [];
        return _this;
    }
    ExecutiveLayout.prototype.ngOnInit = function () {
        if (this.authService.userData.type === logintTypeCorpo) {
            this.menuItems.push({
                label: "116m",
                descr: "Tag List",
                details: "",
                routerLink: "/tag/corp/list",
                iconType: "pg",
                iconName: "home",
                adminU: false,
            });
            this.menuItems.push({
                label: "118",
                descr: "Profile",
                details: "",
                routerLink: "/tag/corp/profile",
                iconType: "pg",
                iconName: "user",
                adminU: false,
            });
            if (this.authService.userData.oa === false &&
                !this.authService.isAdminU()) {
                this.menuItems.push({
                    label: "597",
                    descr: "Hist Log",
                    details: "",
                    routerLink: "/admin/log",
                    iconType: "pg",
                    iconName: "user",
                    adminU: false,
                });
            }
        }
        else if (this.authService.userData.type === logintTypeInd) {
            this.menuItems.push({
                label: "118",
                descr: "Profile",
                details: "",
                routerLink: "/tag/ind/profile",
                iconType: "pg",
                iconName: "user",
                adminU: false,
            });
        }
        if (this.authService.isAdminU()) {
            this.menuItems.push({
                label: "9",
                descr: "Create",
                details: "",
                routerLink: "/admin/create",
                iconType: "pg",
                iconName: "user",
                adminU: true,
            });
            this.menuItems.push({
                label: "595",
                descr: "Corp List",
                details: "",
                routerLink: "/admin/list/corp",
                iconType: "pg",
                iconName: "user",
                adminU: true,
            });
            this.menuItems.push({
                label: "596",
                descr: "Ind.List",
                details: "",
                routerLink: "/admin/list/ind",
                iconType: "pg",
                iconName: "user",
                adminU: true,
            });
            this.menuItems.push({
                label: "597",
                descr: "Hist Log",
                details: "",
                routerLink: "/admin/log",
                iconType: "pg",
                iconName: "user",
                adminU: true,
            });
            this.menuItems.push({
                label: "594",
                descr: "Config",
                details: "",
                routerLink: "/admin/config",
                iconType: "pg",
                iconName: "user",
                adminU: true,
            });
        }
        //
        // this.menuItems.push( {
        //     label:"11",
        //     descr:'Sold',
        //     details:"",
        //     routerLink:"/tag/sold",
        //     iconType:"pg",
        //     iconName:"user",
        //     adminU: true
        // });
        // this.menuItems.push( {
        //     label:"39",
        //     descr:'Stolen',
        //     details:"",
        //     routerLink:"/tag/stolen",
        //     iconType:"pg",
        //     iconName:"user",
        //     adminU: true
        // });
        pg.isHorizontalLayout = true;
        this.changeLayout("horizontal-menu");
        this.changeLayout("horizontal-app-menu");
    };
    ExecutiveLayout.prototype.goHome = function () {
        this.authService.goToHome();
    };
    return ExecutiveLayout;
}(RootLayout));
export { ExecutiveLayout };
